import { createLazyDialog } from '@core/modal'

import type { TDeleteAudioDialogProps } from './DeleteAudioDialog.types'

export const AsyncDeleteAudioDialog = createLazyDialog<
    TDeleteAudioDialogProps,
    'DeleteAudioDialog'
>(
    () => import(/* webpackChunkName: 'dialog-delete-audio' */ './DeleteAudioDialog'),
    'DeleteAudioDialog',
)
